import gql from 'graphql-tag';

export const CHANGE_EMAIL_VERIFY = gql`
  mutation changeEmailVerify($emailChangeVerify: ChangeEmailVerifyInput!) {
    changeEmailVerify(input: $emailChangeVerify) {
      ... on ChangeEmailVerifySuccess {
        ref
      }
      ... on ChangeEmailVerifyFailure {
        error {
          __typename
          message
          code
          reason
          ... on AccountValidationError {
            details {
              message
              code
              path {
                field
                path
              }
              reason
            }
          }
        }
      }
    }
  }
`;
